import { UseDeepLinkParams } from "./types";

const deepLinkKeys = {
  list: (params?: UseDeepLinkParams) =>
    params ? ["deep_links", params] : ["deep_links"],
  one: (id: string) => ["deep_links", id],
};

export default deepLinkKeys;
